module.exports = __webpack_public_path__ + "static/media/Profile2.e08c8a2f.svg";